import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Candidate tipi tanımı
interface Candidate {
  id: number;
  name: string;
  position: string;
  department: string;
  departmentCode: string;
  bio: string;
  linkedin: string;
  image: string;
}

// Aday verisi - Candidates.tsx'den alınan veriler
const candidates: Candidate[] = [
  {
    id: 1,
    name: 'Mehmet İsmet Beşik',
    position: 'Yönetim Kurulu Asıl',
    department: 'Siyaset Bilimi ve Kamu Yönetimi 1981',
    departmentCode: 'ADM',
    bio: "1981 ODTÜ Siyaset Bilimi ve Kamu Yönetimi mezunudur. Kariyerinde Dışbank, GÜRİŞ Holding, METİŞ Holding ve Tepe Altyapı gibi kurumlarda üst düzey finans yöneticiliği yapmış, halen ELMAC Ltd. Şti.'de Finans Direktörü olarak görev yapmaktadır. ODTÜ Atletizm Takımı'nın eski sporcusu, kaptanı, antrenörü ve yöneticisi olan Beşik, 1991'den bu yana ODTÜ bağış kampanyalarının gönüllü destekçisi, mentoru ve 2023-2024 döneminde ODTÜMİST Maraton Çalışma Grubu Koordinatörü olarak aktif görev almıştır.",
    linkedin: 'https://www.linkedin.com/in/ismet-be%C5%9Fik-62754934/',
    image: '/images/candidates/IsmetBesik.jpg',
  },
  {
    id: 2,
    name: 'Orhan Tola',
    position: 'Yönetim Kurulu Asıl',
    department: 'Makina Mühendisliği 1986',
    departmentCode: 'ME',
    bio: "1963 Ankara doğumlu, ODTÜ Makine Bölümü 1986 lisans, 1989 yüksek lisans mezunu olup, 1986-90 yıllarında Aselsan'da çalıştı. 1990 yılında elektronik üretim, pazarlama ve teknik servis konularında faaliyet gösteren şirketini Ankara'da kurdu ve 2018 yılına kadar devam ettirdi. 2018 yılından itibaren firmalara yönetim danışmanlığı hizmeti vermekte olup, üç çocuk babasıdır. Okul yıllarında, hem okul takımında hem de kulüp takımında yarı profesyonel futbol oynamış olup, son on yıldır ultra trail koşuları yapmaktadır ve ODTÜ öğrencilerine burs toplamaktadır.",
    linkedin: 'https://www.linkedin.com/in/orhan-tola-0621273a/',
    image: '/images/candidates/OrhanTola.jpg',
  },
  {
    id: 3,
    name: 'Bektaş Özkan',
    position: 'Yönetim Kurulu Asıl',
    department: 'Fizik 1992',
    departmentCode: 'PHYS',
    bio: "27 yıllık bilgi teknolojileri kariyerinde Anadolu Endüstri Holding, Anadolu Bilişim Hizmetleri ve SabancıDx gibi kurumlarda CIO, CTO ve GMY düzeyinde görevler üstlenmiş; siber güvenlik, bulut teknolojileri ve yönetilen hizmetler alanlarında uzman bir liderdir. Halen bu alanlarda profesyonel çalışmalarına devam etmektedir. 2015'ten bu yana ODTÜMİST üyesi olup, Mentorluk Çalışma Grubu'nda 5 dönem aktif mentor olarak görev almış, 2018'den itibaren Maraton Çalışma Grubu'nda yer almış ve son dönemde bu grubun koordinasyonunu üstlenmiştir. Aynı zamanda Türkiye Kurumsal Yönetim Derneği (TKYD) üyesidir.",
    linkedin: 'https://www.linkedin.com/in/bektasozkan/',
    image: '/images/candidates/bektasozkan.jpg',
  },
  {
    id: 4,
    name: 'Selçuk Koçum',
    position: 'Yönetim Kurulu Asıl',
    department: 'Metalurji Mühendisliği 1992',
    departmentCode: 'METE',
    bio: "Kariyerinde ODTÜ Tahribatsız Muayene Merkezi, United Technology Sikorsky Air Craft, Roketsan, Eczacıbaşı-Lincoln Electric, Swiss Innotech Türkiye gibi birçok yerli ve uluslararası şirkette görev almış, teknoloji girişimciliği ve endüstriyel çözümler alanında uzmanlaşmıştır.  İstanbul ve Ankara' daki ODTÜ Mezun Dernekleri' ne üyedir. Maraton Çalışma Grubu Koordinatörlüğü, Yönetim Kurulu üyeliği ve mentorluk faaliyetleriyle derneğe aktif katkı sağlamaktadır. Aynı zamanda Gençtur, Adım Adım ve Kuzey Ormanları Savunması gibi sosyal girişimlerde gönüllü olarak yer almaktadır.",
    linkedin: 'https://www.linkedin.com/in/selcuk-kocum-144a6b/',
    image: '/images/candidates/SelcukKocum.jpg',
  },
  {
    id: 5,
    name: 'Selma Ergin',
    position: 'Yönetim Kurulu Asıl',
    department: 'Endüstri Mühendisliği 1986',
    departmentCode: 'IE',
    bio: "ODTÜ Endüstri Mühendisliği 1986 yılı mezunudur. Sandoz İlaç, JTI Tütün Ürünleri ve Medicalpark hastaneler grubunda yerel ve global seviyede bilişim, şirket yönetimi görevlerini üstlendi. Dünya tatlısı bir kız evladın annesi olma mutluluğunu yaşıyor. ODTÜ'ye her daim gönül borcu içinde, 2018 yılından beri maraton çalışma grubunda koşuyor ve öğrencileri için burs kampanyası açıyor.",
    linkedin: 'https://www.linkedin.com/in/selma-ergin-b5a8868/',
    image: '/images/candidates/SelmaErgin.jpg',
  },
  {
    id: 6,
    name: 'Tülin Cevizci',
    position: 'Yönetim Kurulu Asıl',
    department: 'Şehir ve Bölge Planlama 1990',
    departmentCode: 'CRP',
    bio: "1990 ODTÜ Şehir ve Bölge Planlama, 1995 Marmara Üniversitesi Çağdaş Yönetim Teknikleri mezunudur. Özel bankalarda kambiyo, muhabir ilişkileri, kurumsal bankacılık ve ticaret finansmanı gibi bölümlerde çalışmıştır. Türkiye'de ilk kez uluslararası ticaret finansmanı ürün pazarlama ve satış departmanını kurmuş, aynı zamanda dünya için örnek teşkil eden finansman modellerini geliştiren ekiplerde yer almıştır. Daha sonra kendi şirketiyle bankalara ve şirketlere danışmanlık hizmeti vermiştir. Pandemi süreciyle birlikte tamamen gönüllülük esaslı çalışmalara yönelmiştir ve çeşitli sivil toplum kuruluşlarında aktif olarak görev almaktadır. KOBİ ve gençler için gönüllü danışmanlık yapmaktadır. AÖF 2.Üniversite Yönetim Bilişim Sistemleri öğrencisidir. MTO Türkiye, İASK Maslak, ÇYDD Beşiktaş YK ve Şehir Plancıları Odası İstanbul, MAG Beşiktaş üyesidir. Çocuklar ve yaşlılarla ilgili projeler özel ilgi alanları arasındadır. ÇYDD ve ODTÜMİST bünyesinde mentordur, aynı zamanda Maraton ve Sinema çalışma gruplarında aktif olarak yer almaktadır. Evli ve bir kız çocuk annesidir.",
    linkedin: 'https://www.linkedin.com/in/tulin-cevizci-55128919/',
    image: '/images/candidates/TulinCevizcioglu.jpg',
  },
  {
    id: 7,
    name: 'Ali Öztüfekçi',
    position: 'Yönetim Kurulu Asıl',
    department: 'Jeoloji Mühendisliği 1998',
    departmentCode: 'GEOE',
    bio: "1998 ODTÜ Jeoloji Mühendisliği mezunudur. 37 yıllık turizm kariyerinde Hilton Grubu'nda koordinatörlük yapmış, FIJET Kültür Rotaları Başkanlığı ve TTYGD Genel Sekreterliği gibi uluslararası görevler üstlenmiştir. ODTÜMİST Arkeoloji Topluluğu Çalışma Grubu'nda uzun yıllardır aktif olarak yer almakta, aynı zamanda EMCC Akredite Mentor olarak ODTÜMİST Mentorlük Programı'nda mentorlük, grup koordinatörlüğü ve genel koordinatörlük görevlerini yürütmektedir. Kültür rotaları, turizm destinasyonları ve sürdürülebilirlik konularında uluslararası projelerde yer almakta olup, kendi eğitim, danışmanlık ve yazılım şirketlerini yönetmektedir.",
    linkedin: 'https://www.linkedin.com/in/ali-oztufekci-76177645/',
    image: '/images/candidates/AliOztufekci.jpg',
  },
  {
    id: 8,
    name: 'Selçuk Saraç',
    position: 'Yönetim Kurulu Yedek',
    department: 'Makina Mühendisliği 1994',
    departmentCode: 'ME',
    bio: "1994 ODTÜ Makina Mühendisliği mezunudur. Profesyonel kariyerinde Eczacıbaşı Topluluğu Yapı Ürünleri Grubu'nda üretim, lojistik birimlerinde çeşitli yöneticilik rollerinde çalıştı. Fransa Insead rehberliğinde inovasyon çalışmalarında bulunarak Yapı Ürünleri Grubunda oluşturulan Mavi Okyanus Stratejisi ekiplerine liderlik etti. Eczacıbaşı yılları sonrası, ABD merkezli Otis Asansör şirketinde Tedarik Zincirini yönetti. Sonrasında Otis'in Türkiye Fabrika Operasyon Direktörlüğüne atanarak, tedarik zinciri yanı sıra imalat, mühendislik ve ihracat operasyonlarını yönetmeye başladı. Halen bu görevini sürdürmektedir.  ODTÜ adına maraton grubunda yer alarak İstanbul Maratonunda birçok defa Burs için koştu. Bununla birlikte Mentorluk programı dahilinde yeni mezunlarımıza İş ve Yaşam mentorluğu vermektedir.",
    linkedin: 'https://www.linkedin.com/in/selcuk-sarac-037a6312/',
    image: '/images/candidates/SelcukSarac.jpg',
  },
  {
    id: 9,
    name: 'Muzaffer Bayazıtoğlu',
    position: 'Yönetim Kurulu Yedek',
    department: 'Jeoloji Mühendisliği 1994',
    departmentCode: 'GEOE',
    bio: "1994 ODTÜ Jeoloji Mühendisliği lisans ve 1998 yüksek lisans mezunudur. Uluslararası madencilik şirketlerinde saha mühendisi olarak başladığı kariyerine, 2007'den bu yana Sandvik firmasında devam etmektedir. Türkiye'de satış yöneticiliği yaptıktan sonra 2015 yılında Almanya'ya taşınmış, burada Kuzey Avrupa Bölge Müdürlüğü ve global satış geliştirme görevlerinde bulunmuştur. Halen yedek parça biriminde global satış kanalları geliştirme sorumluluğu taşımaktadır. Düsseldorf'ta ailesiyle birlikte yaşamakta, bir spor kulübünde 8 yaş altı rugby takımı koçluğu yapmaktadır. Yurt dışında yaşayan ODTÜ mezunlarını bir araya getirmek en büyük hedeflerinden biridir.",
    linkedin: 'https://www.linkedin.com/in/muzafferbayazitoglu/',
    image: '/images/candidates/MuzafferBayazit.jpg',
  },
  {
    id: 10,
    name: 'Damla Kalan Dilekcan',
    position: 'Yönetim Kurulu Yedek',
    department: 'Kimya Mühendisliği 1994',
    departmentCode: 'CHE',
    bio: "1971 Ankara doğumlu. 1994 yılında ODTÜ Kimya Mühendisliği Bölümü'nden mezun oldu. 1995 yılında İstanbul Üniversitesi'nde Uluslararası İşletme Programı'nı tamamladı. Çalışma hayatına Gümüşsuyu Halıları'nda 'Toplam Kalite Uzmanı' olarak başladı. 2 yıl süreyle üretim planlama, ürün  takip ve satış sonrası hizmet bölümlerinin kurulum ve otomasyon projelerinde çalıştı.  Pfizer İlaçları'nda 6 yıl ürün müdürlüğü ve stratejik planlama müdürlüğü görevlerinden sonra Pfizer'den 4 arkadaşı ile birlike Pitstop Sağlık İletişim Ajansı'nı kurdu. 22 yıldır Pitstop'ın kurucu ortaklarından biri olarak başta sağlık iletişimi ve kurumsal iletişim olmak üzere iletişim alanında çalışma hayatına devam ediyor. Evli ve 2 çocuk annesi. İyi derecede Fransızca ve İngilizce biliyor.  ODTÜMİST ile birlikte Bebekliler Derneği, DAK-SAR Denizde Arama Kurtarma Derneği ve ORDOS (Orta Doğu Arama-Kurtarma, Dağcılık ve Doğa Sporları Derneği) üyelikleri bulunmaktadır.",
    linkedin: 'https://www.linkedin.com/in/damla-kalan-dilekcan-027442/',
    image: '/images/candidates/DamlaKalanDilekcan.jpg',
  },
  {
    id: 11,
    name: 'Sedat Taşkeser',
    position: 'Yönetim Kurulu Yedek',
    department: 'Endüstri Mühendisliği 1987',
    departmentCode: 'IE',
    bio: "1987 yılında ODTÜ Endüstri Mühendisliğinden mezun oldu. ER Elektronik A.Ş.'de malzeme planlama ve ERP proje mühendisi olarak başladı; Planlama ve Satınalma alanlarında 7 yıl yöneticilik yaptı. Blanc und Fischer grubunda toplam 22 yıl Satınalma, Bilgi Teknolojileri, İnsan Kaynakları, Genel Yönetim alanlarında yöneticilik ve sonrasında Yönetim Kurulu üyeliği yaptı. ODTÜ atletizm takımında başlayan spor tutkusu mezuniyet sonrasında da devam etti. Uzun mesafe koşularında mastır koşucu olarak yurt içi ve yurt dışı yarışmalarda yarıştı. 2013 yılından beri ODTÜMİST üyesi olarak ODTÜ öğrencilerine burs fonu yaratmak için koşuyor; Maraton Çalışma Gruplarında görev alıyor. ",
    linkedin: 'https://www.linkedin.com/in/sedat-ta%C5%9Fkeser-2212752/',
    image: '/images/candidates/SedatTaskeser.jpg',
  },
  {
    id: 12,
    name: 'Melike Cavcar',
    position: 'Yönetim Kurulu Yedek',
    department: 'Metalurji Mühendisliği 1991',
    departmentCode: 'METE',
    bio: "1969 yılında Eskişehir'de doğmuştur. 1991 yılında Orta Doğu Teknik Üniversitesi Metalurji Mühendisliği Bölümü'nde Lisans, 1994 yılında Yüksek Lisans eğitimini tamamlamıştır. 2014 yılından itibaren Burs için Koşuyorum Kampanyası ile ODTÜ Maraton Grubu'na gönüllü koşucu, 2015 yılında MÇG'ye gönüllü çalışan olmuştur. 2018 yılında YK'nda Yedek Üye olarak görev yapmıştır. ",
    linkedin: 'https://www.linkedin.com/in/melikecavcar/',
    image: '/images/candidates/MelikeCavcar.jpg',
  },
  {
    id: 13,
    name: 'Murat Tuğasaygı',
    position: 'Yönetim Kurulu Yedek',
    department: 'Elektrik Elekronik Mühendisliği 1989',
    departmentCode: 'EEE',
    bio: "1989 ODTÜ Elektrik-Elektronik Mühendisliği mezunudur. ProfiloTelra, Micronas, LG Electronics ve Akademi Çevre gibi firmalarda çeşitli mühendislik ve yöneticilik görevlerinde bulunduktan sonra 2020 yılında emekli olmuştur. Üniversite yıllarında lisanslı karate sporcusu olan Murat Tuğasaygı, son 15 yıldır koşuya ağırlık vermekte; burs sağlamak amacıyla yardımseverlik koşularına aktif olarak katılmaktadır.",
    linkedin: 'https://www.linkedin.com/in/murat-tugasaygi-4983425/',
    image: '/images/candidates/MuratTugasaygi.jpg',
  },
  {
    id: 14,
    name: 'Kadri Özbey',
    position: 'Yönetim Kurulu Yedek',
    department: 'Endüstri Mühendisliği 1989',
    departmentCode: 'IE',
    bio: "1989 ODTÜ Endüstri Mühendisliği mezunudur. Kariyerine Sabancı Holding-Brisa'da başlamış, Ev tekstili sektöründe genç yaşta Genel Müdürlük görevine yükselmiş, Kriz dönemlerinde şirket dönüşüm süreçlerine liderlik etmiştir. 2008 yılında Azerbaycan'da Gayrimenkul Geliştirme alanında önemli AVM ve Karma Projeleri hayata geçiren ekibe Liderlik etmiş; sonrasında kendi Danışmanlık ve Distribütörlük şirketlerini kurmuştur. 2017'den beri Türkiye'de Proje bazlı Satış ve Danışmanlık faaliyetlerini sürdürmektedir. 1991 yılında kurmuş olduğu Brisa Öğrenim Destekleme Topluluğu halen yüzlerce öğrenciye karşılıksız Burs vermektedir. 1991-1995 yılları arasında Kocaeli Makine Mühendisleri Odası Yönetim Kurulu'nda görev almıştır. Evli ve iki çocuk babasıdır.",
    linkedin: 'https://www.linkedin.com/in/kadri-%C3%B6zbey-31977913/',
    image: '/images/candidates/KadriOzbey.jpg',
  },
  {
    id: 15,
    name: 'Zeynep Berberoğlu',
    position: 'Disiplin Asıl',
    department: 'Siyaset Bilimi ve Kamu Yönetimi 1983',
    departmentCode: 'ADM',
    bio: "1983 ODTÜ İdari Bilimler Fakültesi Siyaset Bilimi ve Kamu Yönetimi Bölümü mezunudur. Türkiye İş Bankası, Uluslararası Endüstri Ve Ticaret Bankası, Garanti Bankası'nda insan kaynakları, eğitim alanında ve değişim projelerinde çeşitli roller üstlenmiştir. Doğuş Grubunun insan kaynakları yönetimi şirketi Humanitas'ta üst düzey yöneticilik yapmıştır.  2003 yılından beri insan kaynakları danışmanı olarak farklı sektörlerdeki, farklı şirketlere hizmet vermektedir. Agile Partners Danışmanlık Şirketinin kurucu ortağıdır. PERYÖN ve ODTÜMİST üyesidir. ODTÜ'lü Yalnız Değilsin ve ODTÜMİST mentorluk programlarının geliştirilmesi ve yürütülmesinde aktif görev üstlenmiştir.",
    linkedin: 'https://www.linkedin.com/in/zeynep-berberoglu-0b90a81/',
    image: '/images/candidates/ZeynepBerberoglu.jpg',
  },
  {
    id: 16,
    name: 'Türkü Karan',
    position: 'Disiplin Asıl',
    department: 'İşletme 1991',
    departmentCode: 'MAN',
    bio: "1991 ODTÜ İşletme Bölümü mezunudur. Çalışma hayatına  mezun olur olmaz Ankara'da T. İş Bankasında başlamış, 1994 yılında İstanbul'a taşındıktan sonra çeşitli bankalarda çalışma hayatına devam etmiştir. 1998-2000 yılları arasında ABD Washington DC Georgetown University'de MBA yapmıştır. Halen çalışan bir emekli olarak bir portföy yönetim şirketinde danışmanlık yapmaktadır. 2000'lerin başından beri ODTÜMİST üzerinden burs vermektedir. 2010 yılından itibaren Burs Çalışma Grubuna aktif bir gönüllü olarak katkı sağlamış, zaman zaman grubun koordinatörlüğü üstlenmiş, mentorluk yapmış, maratonda bağış toplamıştır.",
    linkedin: 'https://www.linkedin.com/in/turku-karan-457975b/',
    image: '/images/candidates/turkukaran.jpg',
  },
  {
    id: 17,
    name: 'Şule Onur',
    position: 'Disiplin Asıl',
    department: 'Şehir ve Bölge Planlama 1990',
    departmentCode: 'CRP',
    bio: "ODTÜ Şehir ve Bölge Planlama Bölümü 1990 yılında mezun olmuştur. Aynı yıl Çankaya Belediyesinde çalışmaya başladı. 2001 yılından itibaren Kadıköy Belediyesinde farklı departmanlarda yönetici olarak çalıştı. Dünya Sağlık Örgütü Danışma Kurulu üyeliği yanı sıra çeşitli sivil toplum örgütleri, meslek odaları, üniversiteler ve özel sektör temsilcileri ile iş birlikleri geliştirerek ulusal ve uluslararası projeler geliştirdi. Ulusal ve uluslararası yarışmalarda çeşitli ödüller kazandı. Halen aynı kurumda çalışmaya devam etmektedir. 2016 yılında TAKSAV Kültür Vakfında başladığı yağlı boya resim çalışmalarına ressam Mustafa Özel'in atölyesinde devam etmektedir. Fenerbahçe Spor Kulübü kongre üyesidir. Evli ve bir çocuk Annesidir.",
    linkedin: '',
    image: '/images/candidates/SuleOnur.jpg',
  },
  {
    id: 18,
    name: 'Yasemin Civelekoğlu',
    position: 'Disiplin Yedek',
    department: 'Kimya Mühendisliği 1978',
    departmentCode: 'CHE',
    bio: "1978 ODTÜ Kimya Mühendisliği lisans ve 1980 yüksek lisans mezunudur. 30 yıl boyunca Burla A.Ş.'de teknik satış ve bölüm yöneticiliği görevlerinde bulunmuş, 2012 yılında emekli olmuştur. ODTÜMİST'te iki dönem yönetim kurulu üyeliği yapmış, Edebiyat Kulübü, Maraton ve Mentorluk Çalışma Gruplarının kuruluşundan itibaren aktif olarak yer almıştır. Aynı zamanda Adalar Vakfı Yönetim Kurulu üyesidir; iki kız annesi ve üç torun sahibidir.",
    linkedin: 'https://www.linkedin.com/in/yasemin-civelekoglu-269a7b12/',
    image: '/images/candidates/YaseminCivelekoglu.jpg',
  },
  {
    id: 19,
    name: 'Ali Haydar Elveren',
    position: 'Disiplin Yedek',
    department: 'İktisat 1990',
    departmentCode: 'ECON',
    bio: "1990 ODTÜ İktisat mezunudur; İktisat, Aktüerya ve Klinik Psikoloji alanlarında üç yüksek lisans derecesine sahiptir. Uzun yıllar Hazine Müsteşarlığı'nda üst düzey görevlerde bulunmuş, Özel Emeklilik Dairesi Başkanı olarak önemli yasal altyapıların oluşumuna liderlik etmiş ve Emeklilik Gözetim Merkezi'nin kurulmasına öncülük etmiştir. Halen kurucusu olduğu Adendum Danışman Grup Şirketleri ile aktüeryal danışmanlık faaliyetlerini sürdürmektedir. ODTÜMİST üyesidir.",
    linkedin: 'https://www.linkedin.com/in/ali-haydar-elveren-2b76a516/',
    image: '/images/candidates/AliHaydarElveren.jpg',
  },
  {
    id: 20,
    name: 'Serpil Uzun',
    position: 'Disiplin Yedek',
    department: 'İktisat 1994',
    departmentCode: 'ECON',
    bio: "1994 ODTÜ İktisat mezunudur. Parker Hannifin'de Türkiye ve ardından Orta & Doğu Avrupa satış genel müdürlüğü görevlerinde 15 yılı aşkın süre liderlik yapmış, ardından Bosch Rexroth'ta VP Sales Indirect Channels pozisyonunda kariyerine devam etmiştir. Uzun, mühendislik odaklı üretim, tedarik zinciri ve satış yönetimi deneyimini; Almanya ve Türkiye'de farklı sektörlerde danışmanlık yaparak pekiştirmiştir. ",
    linkedin: 'https://www.linkedin.com/in/serpil-uzun-12447aa/',
    image: '/images/candidates/SerpilUzun.jpg',
  },
  {
    id: 22,
    name: 'Oğuzhan Aygün',
    position: 'Denetleme Asıl',
    department: 'Endüstri Mühendisliği 1986',
    departmentCode: 'IE',
    bio: "1986 ODTÜ Endüstri Mühendisliği mezunudur. Kariyerinde Goodyear, Adidas, DHL, Omsan, Beymen ve Tatko gibi önemli firmalarda görev almış; halen Karınca Lojistik'te Genel Müdür olarak profesyonel yaşamına devam etmektedir.",
    linkedin: 'https://www.linkedin.com/in/oguzhan-aygun-77204315/',
    image: '/images/candidates/oguzhanaygun.jpg',
  },
  {
    id: 23,
    name: 'Özden Duymaz',
    position: 'Denetleme Asıl',
    department: 'Maden Mühendisliği 2010',
    departmentCode: 'MINE',
    bio: "ODTÜ Maden Mühendisliği 2010 mezunudur. Enerji sektöründeki deneyimi sonrasında Sivil Toplum Kuruluşlarının AB, GIZ, WB gibi yabancı kaynaklı fonlarla yürüttükleri projelerinde koordinatörlük ve yöneticilik yapmıştır. İşletme yüksek lisansı yapmış olup; KOBİ Danışmanlığı, Eğitmenlik ve Proje Uzmanlığı görevlerini bağımsız yürütmek adına 2019 yılında kendi eğitim, danışmanlık ve organizasyon şirketini kurmuştur. Girişimcilik ve Sosyal Girişimcilik konularında tez yazmaktadır. ODTÜMİST ve TEV Mentorluk Programlarında; UNDP, Koç Vakfı ve Ford Otosan'ın projelerinde Mentorluk yapmaktadır. ODTÜ Mezunları Gaziantep Derneği'nin başkan yardımcılığı görevini 6 yıldır yürütmektedir. Öğrencilik döneminde ODTÜ Spor Kulübü adına Serbest Dalış yarışmalarına katılmış, Türkiye 2.liği kazanarak, 3 yıl milli takımda yer almıştır.",
    linkedin: 'https://www.linkedin.com/in/ozden-duymaz-60499158/',
    image: '/images/candidates/OzdenDuymaz.jpg',
  },
  {
    id: 24,
    name: 'M. Ali Acartürk',
    position: 'Denetleme Yedek',
    department: 'İşletme 1978',
    departmentCode: 'MAN',
    bio: "1954 Eskişehir doğumlu. ODTÜ İşletme bölümünü Sümerbank bursu ile okudu. Sümerbank, Devlet Yatırım Bankası, Sasa, Temsa, Toyotasa ve Esselte Leitz A.Ş. şirketlerinde yöneticilik yaptı. ODTÜMİST YK'da 8 yıl görev aldı. 2014- 2016 döneminde YK başkanlığı yaptı. YKKED (Yeni Kuşak Köy Enstitülüler Derneği) üyesi. İki dönem Denetleme Kurulu başkanlığı yaptı.  ODTÜ'ye vefa borcunu ödemeye devam ediyor.",
    linkedin: 'https://www.linkedin.com/in/mehmet-ali-acart%C3%BCrk-09046a1a3/',
    image: '/images/candidates/MAliAcarturk.jpg',
  },
  {
    id: 25,
    name: 'Barçın Yinanç',
    position: 'Denetleme Yedek',
    department: 'Uluslararası İlişkiler 1991',
    departmentCode: 'IR',
    bio: "1991 ODTÜ Uluslararası İlişkiler mezunudur. Halen T24 dış politika analisti olarak çalışıyor. Yazıları ayrıca TurkeyinDepth ve Yetkinreport'ta da yayınlanıyor. 1991 yılından bu yana Türk dış politikasını takip ediyor. 1991-2005 yılları arasında sırasıyla Milliyet Gazetesi, TV8 ve CNN Türk Ankara bürolarında diplomasi muhabiri olarak çalıştı. Çok sayıda uluslararası toplantıyı yerinden izledi, yabancı liderlerle röpörtajlar gerçekleştirdi. 2005 yılında İstanbul'a taşınarak CNN Türk ve Referans gazetesinde çalıştı. Ardından Hürriyet Daily News'a geçti, gazetenin çeşitli kademelerinde görev aldı. Son on yıldır gazetenin röportajlarını gerçekleştirmesinin yanı sıra dış politika ve uluslararası ilişkiler ağırlıklı köşe yazarlığı yaptı. Yinanç ODTÜ uluslararası ilişkiler bölümü mezunu.",
    linkedin: 'https://www.linkedin.com/in/bar%C3%A7%C4%B1n-yinan%C3%A7-57b90356/',
    image: '/images/candidates/BarcinYinanc.jpg',
  },
  {
    id: 26,
    name: 'Nebil Göğüş',
    position: 'Denetleme Yedek',
    department: 'İşletme 1979',
    departmentCode: 'MAN',
    bio: "1979 yılı Kasım dönemi ODTÜ İdari İlimler Fakültesi, İşletme Bölümü mezunu. 1980 yılında Ereğli Demir Çelik, 1982'de Bekoteknik fabrikalarında Satınalma uzmanı olarak, 1985-2004 yılları arasında AKÇANSA Çimento fabrikasında Yatırım Planlama Uzmanı olarak çalıştı. 2005-2013 yılları arasında muhtelif Sivil Toplum derneklerinde ve KOBİ ölçeğindeki tekstil ve sağlık sektöründe faaliyet gösteren firmaların derneklerinde Genel Sekreter ve Danışman olarak görev yapmıştır.",
    linkedin: 'https://www.linkedin.com/in/nebil-gogus-34b83253/',
    image: '/images/candidates/NebilGogus.jpg',
  },
];

// Adayları pozisyonlarına göre gruplandırma
const groupedCandidates: Record<string, Candidate[]> = {
  'Yönetim Kurulu Asıl': candidates.filter(c => c.position === 'Yönetim Kurulu Asıl'),
  'Yönetim Kurulu Yedek': candidates.filter(c => c.position === 'Yönetim Kurulu Yedek'),
  'Disiplin Asıl': candidates.filter(c => c.position === 'Disiplin Asıl'),
  'Disiplin Yedek': candidates.filter(c => c.position === 'Disiplin Yedek'),
  'Denetleme Asıl': candidates.filter(c => c.position === 'Denetleme Asıl'),
  'Denetleme Yedek': candidates.filter(c => c.position === 'Denetleme Yedek'),
};

const CandidateBios: React.FC = () => {
  // Sayfa yüklendiğinde en üste kaydır
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // PDF olarak kaydetme fonksiyonu
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="bg-white">
      <div className="bg-odtu-red py-12 print:py-4">
        <div className="container">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center print:text-black">Aday Özgeçmişleri</h1>
        </div>
      </div>
      
      <div className="container section">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-8 print:hidden">
            <p className="text-lg text-center flex-grow">
              ODTÜlüyüzBiz ekibi olarak, ODTÜ İstanbul Mezunları Derneği yönetimine aday olan ekibimizin özgeçmişlerini inceleyebilirsiniz.
            </p>
            <button 
              onClick={handlePrint}
              className="ml-4 px-4 py-2 bg-odtu-red text-white rounded-md hover:bg-odtu-dark-red transition-colors duration-300 flex items-center"
            >
              <span className="mr-2">⬇️</span>
              PDF Olarak Kaydet
            </button>
          </div>
          
          <p className="text-lg text-center mb-12 hidden print:block">
            ODTÜlüyüzBiz ekibi olarak, ODTÜ İstanbul Mezunları Derneği yönetimine aday olan ekibimizin özgeçmişleri.
          </p>
          
          {/* Pozisyonlara göre gruplandırılmış adaylar */}
          {Object.entries(groupedCandidates).map(([position, positionCandidates]) => (
            <div key={position} className="mb-16 print:page-break-inside-avoid">
              <h2 className="text-2xl font-bold text-odtu-red mb-6 pb-2 border-b-2 border-odtu-light-gray">{position}</h2>
              <div className="space-y-8">
                {positionCandidates.map((candidate) => (
                  <div key={candidate.id} className="bg-odtu-light-gray rounded-lg overflow-hidden shadow-md print:break-inside-avoid print:mb-4">
                    <div className="flex flex-col md:flex-row">
                      {/* Sol taraf - Resim ve isim */}
                      <div className="md:w-1/5 p-3 print:w-1/6">
                        <div className="h-40 md:h-48 relative bg-white p-2 border-2 border-odtu-red rounded-lg overflow-hidden mb-2 print:h-32">
                          <img 
                            src={candidate.image} 
                            alt={`${candidate.name}`}
                            className="w-full h-full object-contain"
                            onError={(e) => {
                              // Resim yüklenemezse varsayılan bir resim göster
                              (e.target as HTMLImageElement).src = '/images/candidates/default-profile.svg';
                            }}
                          />
                        </div>
                        <h3 className="text-lg font-bold text-odtu-red text-center">{candidate.name}</h3>
                      </div>
                      
                      {/* Sağ taraf - Özgeçmiş */}
                      <div className="md:w-4/5 p-5 bg-white border-l-4 border-odtu-red print:w-5/6">
                        <p className="text-sm md:text-base text-gray-700 leading-relaxed print:text-sm">{candidate.bio || `${candidate.department} mezunu.`}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          
          <div className="mt-12 text-center print:hidden">
            <p className="text-lg mb-6">
              16 Mart 2025 tarihinde gerçekleşecek Seçimli Genel Kurul'da desteğinizi bekliyoruz.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/candidates" className="btn btn-primary">
                Aday Listesine Dön
              </Link>
              <a 
                href="mailto:info@odtuluyuz.org" 
                className="btn btn-secondary"
              >
                Bizimle İletişime Geçin
              </a>
            </div>
          </div>
          
          <div className="hidden print:block text-center mt-8 pt-4 border-t">
            <p className="text-sm">
              © {new Date().getFullYear()} ODTÜlüyüzBiz - İstanbul ODTÜ Mezunları Derneği Yönetim Kurulu Adayları
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateBios; 